import { IconButton, Table, TableBody, TableHead, TableRow } from '@mui/material';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  NoDataSkeleton,
} from '../../../common/components';
import { formatCurrency } from '../utils/regularizedPlansUtils';

const RegularizedPlansDataTable = ({ data, isLoading, onViewDetails, LoadingComponent }) => {
  const formatTotal = (total) => {
    const numericTotal = Number(total ?? 0);
    const roundedTotal = Number.isNaN(numericTotal) ? 0 : Math.round(numericTotal);
    return formatCurrency(roundedTotal);
  };

  return (
    <GeneralTableBox>
      <Table aria-label="regularized plans table">
        <TableHead>
          <TableRow>
            <HeadTableCell wmd="15%" wxs="15%">
              Orden
            </HeadTableCell>
            <HeadTableCell wmd="25%" wxs="25%">
              Suscriptores
            </HeadTableCell>
            <HeadTableCell wmd="15%" wxs="15%">
              Cuotas regulariz.
            </HeadTableCell>
            <HeadTableCell wmd="15%" wxs="15%">
              Adecuaciones regulariz.
            </HeadTableCell>
            <HeadTableCell wmd="15%" wxs="15%">
              Total regularizado
            </HeadTableCell>
            <HeadTableCell wmd="15%" wxs="15%">
              Ver
            </HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <LoadingComponent />
          ) : data && data.length > 0 ? (
            data.map((item, index) => (
              <TableRow key={index}>
                <RowTableCell>{item.header.contract_number}</RowTableCell>
                <RowTableCell>{item.header.subscriber}</RowTableCell>
                <RowTableCell>{item.header.regularized_fees}</RowTableCell>
                <RowTableCell>{item.header.regularized_adjustments}</RowTableCell>
                <RowTableCell>{formatTotal(item.header.total)}</RowTableCell>
                <RowTableCell>
                  <IconButton
                    onClick={() => onViewDetails(item)}
                    sx={{
                      '&:hover': {
                        transform: 'scale(1.1)',
                        backgroundColor: 'rgba(94, 137, 79, 0.08)',
                      },
                    }}
                  >
                    <DocumentScannerIcon sx={{ color: '#5e894f' }} />
                  </IconButton>
                </RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton
              colSpan={6}
              message="No se encontraron planes regularizados"
            />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default RegularizedPlansDataTable;
